import httpClient from "Api/httpClient";

const END_POINT = "/forms";

const getForms = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getForm = (form_id) => {
    if (!form_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + form_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printForm = (form_id) => {
    if (!form_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?form_id=" + form_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createForms = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateForms = (payload, form_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + form_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteForms = (form_id) => {
    const DELETE_END_POINT = END_POINT + "/" + form_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

const getFormZip = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    const SINGLE_END_POINT = "/generate/frontend";
    return httpClient.get(SINGLE_END_POINT, { retryTimes: 3, params: body });
};

export { getForms, getForm, printForm, createForms, updateForms, deleteForms, getFormZip };
